/* eslint-disable import/order */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FindStandardProcessOptions, StandardProcessApi } from 'api';

export const findStandardProcess = createAsyncThunk<
  any,
  FindStandardProcessOptions,
  { rejectValue: { message: string } }
>(
  'standardProcess/findStandardProcess',
  async (options, { rejectWithValue }) => {
    try {
      return await StandardProcessApi.find(options);
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface StandardProcessState {}

const initialState: StandardProcessState = {};

const standardProcessSlice = createSlice({
  name: 'standardProcess',
  initialState,
  reducers: {},
  // extraReducers: builder => {},
});

const { reducer: standardProcessReducer } = standardProcessSlice;

export default standardProcessReducer;
